var _path, _rect, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassWithVinegar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 90,
    viewBox: "0 0 63 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671575 3 1.5 3H1.60938C1.8047 3 2 4 2 4V86C2 88.2091 3.79086 90 6 90H57C59.2091 90 61 88.2091 61 86V4C61 4 61.1953 3 61.3906 3H61.5C62.3284 3 63 2.32843 63 1.5C63 0.671573 62.3284 0 61.5 0H61H2H1.5Z",
    fill: "#CDE2ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 25,
    height: 2,
    rx: 1,
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14267 61L54.8695 60.9631C57.148 60.9631 59 59.0959 59 56.7988V51.5803C39.3954 50.8923 29.0321 48 4 48L4 56.8233C4 59.1328 5.85202 61 8.14267 61Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 55.2V83.7989C4 86.1287 5.85038 88.0123 8.139 87.9999L54.8245 87.9628C57.1009 87.9628 59 85.9974 59 83.68V49.44C59 49.0187 58.9757 48.4213 59 48C39.7902 48.1859 30.7949 55.2 4 55.2Z",
    fill: "#66CEF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 12,
    height: 78,
    rx: 3,
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassWithVinegar);
export default __webpack_public_path__ + "static/media/glass_with_vinegar.414f49c944f3ff1a3a6539ef56f92f0b.svg";
export { ForwardRef as ReactComponent };